<template>
  <ul class="nav navbar-nav nav-mobile-menu">
    <slot></slot>
  </ul>
</template>
<script>
export default {}
</script>
<style>
  .nav-mobile-menu {
    color: black !important;
  }
</style>
